
export function formatHash (value) {
  return value
    .replace('#', '')
    .substring(0, 36)
}
